import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SSO_ERRORS = {
    not_provisioned: "Your email is not provisioned in LandLogic NexusOne — contact Planning Services.",
    authentication_failed: "Microsoft could not verify your sign-in. Please try again.",
    invalid_state: "Your sign-in session expired. Please try again.",
    missing_code: "No sign-in response received from Microsoft.",
    missing_exchange: "No sign-in session found — start from the sign-in page.",
    not_configured: "Microsoft sign-in is not configured yet.",
    no_email: "Your Microsoft account did not return an email address.",
};

export default function SsoCallback() {
    const { loginWithToken } = useAuth();
    const { tr } = useLanguage();
    const navigate = useNavigate();
    const [error, setError] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const exchange = params.get("exchange");
        const err = params.get("error");
        if (err) { setError(err); return; }
        if (!exchange) { setError("missing_exchange"); return; }
        axios.post(`${API}/auth/entra/exchange`, { exchange })
            .then(({ data }) => {
                loginWithToken(data.token, data.user);
                window.history.replaceState({}, document.title, "/sso/callback");
                navigate(data.user.role === "developer" ? "/developer" : "/dashboard", { replace: true });
            })
            .catch(() => setError("exchange_failed"));
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F4F7FA]" data-testid="sso-callback">
            {error ? (
                <div className="text-center" data-testid="sso-error">
                    <p className="text-sm font-bold text-red-500">{tr("Microsoft sign-in failed")} — {tr(SSO_ERRORS[error] || "Microsoft could not verify your sign-in. Please try again.")}</p>
                    <button onClick={() => navigate("/login")} className="mt-4 text-sm font-bold text-[#0092B0] hover:underline">{tr("Back to sign in")}</button>
                </div>
            ) : (
                <div className="flex items-center gap-3 text-slate-500 text-sm font-semibold">
                    <Loader2 className="w-5 h-5 animate-spin text-[#00B4D8]" /> {tr("Completing Microsoft sign-in…")}
                </div>
            )}
        </div>
    );
}
